/* @ngInject */
const movementRequest = (
  $q,
  movementResource,
  valueHandler,
  errorHandler,
  labels
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$movement.getBySearch'
      movementResource.post({
        action: 'search',
      }, { search: _data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            movements: res.data,
            message: labels.movement.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.movement.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  // self.countBySearch = async (_data) => {
  //   return $q((resolve, reject) => {
  //     const functionName = '$movement.countBySearch'
  //     movementResource.post({
  //       action: 'count-by-search',
  //     }, _data, (res) => {
  //       if (res && res.success) {
  //         resolve(res.data)
  //       } else if (valueHandler.isString(res)) {
  //         reject(res)
  //       } else {
  //         errorHandler.message(res, functionName, _data)
  //         reject(labels.movement.log.search.failure)
  //       }
  //     }, (error) => {
  //       errorHandler.status(error, functionName)
  //       reject(labels.log.failure)
  //     })
  //   })
  // }


  self.countBySearch = async (_data) => {
    return $q(async (resolve, reject) => {
      try {
        const response = await self.getBySearch(_data)
        const count = response.movements.length
        resolve(count)
      } catch (error) {
        reject(error)
      }
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$movement.delete'
      movementResource.delete({
        action: _id,
      }, (res) => {
        if (res && res.success) {
          resolve(labels.movement.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.movement.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default movementRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/request.service.js